"use strict";
(() => {
	var g = {
		exchangeRate: 1.95583,
		updateDelay: 150,
		scanInterval: 500,
		maxRetries: 3,
		enableLogging: !!window.DEBUG_CURRENCY_CONVERTER,
		debugMode: !!window.DEBUG_CURRENCY_CONVERTER,
		debugSelectors: window.DEBUG_SELECTORS || [],
		displayFormat: "inline",
		precision: 2,
		siblingModeSelectors: [
			".product__price .price__pricing-group .price-item",
		],
		ignoredSelectors: ["#easysell-modal"],
	};
	var S = {
			bgn: {
				symbols: [
					"\u043B\u0432",
					"\u043B\u0435\u0432\u0430",
					"\u043B\u0435\u0432",
					"BGN",
					"bgn",
					"\u043BB",
				],
				patterns: [
					/(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)\s*(лв\.?|лева|лев|BGN|bgn|лB)/gi,
					/(лв\.?|лева|лев|BGN|bgn|лB)\s*(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)/gi,
					/(BGN|bgn|лB)\u00A0(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)/gi,
					/(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)\u00A0(лв\.?|лева|лев|BGN|bgn|лB)/gi,
					/(BGN|bgn|лB)&nbsp;(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)/gi,
					/(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)\s*&nbsp;(лв\.?|лева|лев|BGN|bgn|лB)/gi,
					/(\d+)<sup>(\d{1,2})\s*(лв\.?|лева|лев|BGN|bgn|лB)<\/sup>/gi,
					/(\d+)<sup>(\d{1,2})<\/sup>\s*(лв\.?|лева|лев|BGN|bgn|лB)/gi,
					/<span[^>]*>(\d+)<sup>(\d{1,2})\s*(лв\.?|лева|лев|BGN|bgn|лB)<\/sup><\/span>/gi,
					/(\d+)<sup[^>]*class="price__suffix"[^>]*>\.(\d{1,2})<\/sup><span[^>]*class="price__prefix"[^>]*>(лв\.?|лева|лев|BGN|bgn|лB)<\/span>/gi,
					/(\d+)<sup[^>]*>\.?(\d{1,2})<\/sup><span[^>]*>(лв\.?|лева|лев|BGN|bgn|лB)<\/span>/gi,
					/(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)\s*(лв\.?|лева|лев|лB)(?=\s|$|[^\w\d])/gi,
				],
				convertTo: "EUR",
			},
			eur: {
				symbols: [
					"\u20AC",
					"EUR",
					"eur",
					"Eur",
					"\u0435\u0432\u0440\u043E",
					"euro",
				],
				patterns: [
					/(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)\s*(€|EUR|eur|Eur|евро|euro)/gi,
					/(€|EUR|eur|Eur|евро|euro)\s*(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)/gi,
					/(\d+)<sup>(\d{1,2})\s*(€|EUR|eur|Eur|евро|euro)<\/sup>/gi,
					/(\d+)<sup>(\d{1,2})<\/sup>\s*(€|EUR|eur|Eur|евро|euro)/gi,
					/<span[^>]*>(\d+)<sup>(\d{1,2})\s*(€|EUR|eur|Eur|евро|euro)<\/sup><\/span>/gi,
				],
				convertTo: "BGN",
			},
		},
		$ = [
			'[class*="price"]',
			'[class*="cost"]',
			'[class*="amount"]',
			"[data-price]",
			".money",
			".currency",
			".total",
			".subtotal",
			"price-money",
			".grid-product__price",
			".block-price__regular",
			".prvw_totalAmount_price_0",
			'[id*="totalAmount"]',
			".grid-product__price--current",
			".product-block-price",
			"[data-product-price]",
			".tpo_product_price",
			".tpo_additional-price",
			".tpo_option_type_label",
			".boost-sd__product-price",
			".boost-sd__product-price-wrapper",
			".boost-sd__format-currency",
			".bndlr-money",
			".bndlr-old-price",
			".bndlr-new-price",
			".bndlr-product-price",
			".accordion__title",
			".accordion h3",
			"h3.accordion__title",
			".cart-items__price",
			"text-component",
			".cart-items__details",
			".quantity-break",
			".quantity-break__price",
			".quantity-break__compare-price",
			'[data-essential-upsell-element="regular-price"]',
			'[data-essential-upsell-element="price"]',
		];
	var M = (y, e) => {
			let t;
			return function (...r) {
				let o = () => {
					(clearTimeout(t), y(...r));
				};
				(clearTimeout(t), (t = setTimeout(o, e)));
			};
		},
		x = (y, e) => {
			let t;
			return function () {
				let s = arguments,
					r = this;
				t || (y.apply(r, s), (t = !0), setTimeout(() => (t = !1), e));
			};
		},
		p = class {
			static parseNumber(e, t) {
				if (t) {
					let n = parseFloat(e) || 0,
						i = parseFloat(t) || 0;
					return n + i / 100;
				}
				let s = e.replace(/\s/g, ""),
					r = s.lastIndexOf(","),
					o = s.lastIndexOf(".");
				if (r > o && r > -1) {
					let n = s.substring(r + 1);
					n.length <= 2 && /^\d+$/.test(n)
						? (s = s.replace(/\./g, "").replace(",", "."))
						: (s = s.replace(/,/g, ""));
				} else if (o > r && o > -1) {
					let n = s.substring(o + 1);
					n.length <= 2 && /^\d+$/.test(n)
						? (s = s.replace(/,/g, ""))
						: (s = s.replace(/\./g, ""));
				}
				return parseFloat(s);
			}
			static formatNumber(e, t = "bg-BG") {
				return new Intl.NumberFormat(t, {
					minimumFractionDigits: g.precision,
					maximumFractionDigits: g.precision,
				}).format(e);
			}
			static convertCurrency(e, t) {
				return t === "BGN" ? e / g.exchangeRate : e * g.exchangeRate;
			}
			static createConvertedDisplay(e, t, s) {
				return ` <span class="currency-converted">(${this.formatNumber(t)} ${s === "EUR" ? "\u20AC" : "\u043B\u0432"})</span>`;
			}
		};
	var L = class {
		constructor() {
			try {
				((this.processedElements = new Set()),
					(this.convertedElements = new Set()),
					(this.observer = null),
					(this.mainInterval = null),
					(this.stats = { converted: 0, errors: 0 }),
					(this.debugTargetSelector = null),
					(this.convertFrom = window.CURRENCY_CONVERT_FROM || "BGN"),
					(this.convertTo = window.CURRENCY_CONVERT_TO || "EUR"),
					(this.useCssMode = window.CURRENCY_USE_CSS_MODE || !1),
					this.useCssMode && this.injectCssStyles(),
					this.init(),
					(window.CurrencyConverterDebug = {
						watchSelector: (e) => {
							((this.debugTargetSelector = e),
								console.log(
									`\u{1F3AF} Now watching only: ${e}`,
								));
						},
						stopWatch: () => {
							((this.debugTargetSelector = null),
								console.log(
									"\u{1F441}\uFE0F Stopped targeted watching",
								));
						},
						reprocess: (e) => {
							let t = document.querySelectorAll(e);
							(console.log(
								`\u{1F504} Reprocessing ${t.length} elements matching: ${e}`,
							),
								t.forEach((s) => {
									(s.removeAttribute(
										"data-currency-converted",
									),
										this.processedElements.delete(s),
										this.processElement(s));
								}));
						},
						checkElement: (e) => {
							let t = document.querySelector(e);
							t &&
								console.log("Element info:", {
									hasDataAttr: t.hasAttribute(
										"data-currency-converted",
									),
									innerHTML:
										t.innerHTML.substring(0, 100) + "...",
									textContent:
										t.textContent?.substring(0, 100) +
										"...",
									hasConvertedSpans: !!t.querySelector(
										".currency-converted",
									),
									isInProcessedSet:
										this.processedElements.has(t),
								});
						},
					}));
			} catch (e) {
				throw (
					console.error(
						"\u{1F4A5} Error in CurrencyConverter constructor:",
						e,
					),
					console.error("\u{1F41B} Constructor stack:", e.stack),
					e
				);
			}
		}
		injectCssStyles() {
			let e = "currency-converter-css-mode-styles";
			if (document.getElementById(e)) return;
			let t = document.createElement("style");
			((t.id = e),
				(t.textContent = `
            /* CSS mode: display converted price via ::after pseudo-element */
            [data-converted-price]::after {
                content: " (" attr(data-converted-price) ")";
                font-size: inherit;
                color: inherit;
                font-weight: inherit;
            }
        `),
				document.head.appendChild(t),
				this.log("\u{1F489} Injected CSS styles for ::after mode"));
		}
		init() {
			try {
				(this.log(
					"\u{1F680} Initializing Advanced Currency Converter...",
				),
					this.log(`\u{1F4CA} Config: ${JSON.stringify(g)}`),
					this.log(
						`\u{1F504} Converting from ${this.convertFrom} to ${this.convertTo}`,
					),
					this.log(`\u{1F3A8} CSS mode: ${this.useCssMode}`),
					this.log(`\u{1F310} Current URL: ${window.location.href}`),
					this.log(
						`\u{1F4C4} Document ready state: ${document.readyState}`,
					),
					this.log("\u{1F9EA} Running diagnostics..."),
					this.runDiagnostics(),
					this.log("\u2705 Diagnostics completed"),
					this.log("\u{1F50D} Starting initial price scan..."),
					this.scanForPrices(),
					this.log("\u2705 Initial scan completed"),
					this.log("\u{1F440} Setting up observers..."),
					this.setupObservers(),
					this.log("\u2705 Observers setup completed"),
					this.log("\u{1F527} Setting up API..."),
					this.setupAPI(),
					this.log("\u2705 API setup completed"),
					this.log(
						"\u2705 Currency Converter initialized successfully",
					),
					setTimeout(() => {
						(this.log("\u{1F504} Running delayed diagnostics..."),
							this.scanForPrices());
					}, 100));
			} catch (e) {
				throw (
					console.error("\u{1F4A5} Error in init method:", e),
					console.error("\u{1F41B} Init stack:", e.stack),
					e
				);
			}
		}
		runDiagnostics() {
			try {
				this.log("\u{1F50D} Running diagnostics...");
				let e = "100 \u043B\u0432, 50 EUR, \u20AC25.99, 1,234.56 BGN";
				this.log(`\u{1F9EA} Testing with: "${e}"`);
				let t = !1;
				(Object.entries(S).forEach(([r, o]) => {
					if (r.toLowerCase() !== this.convertFrom.toLowerCase()) {
						this.log(
							`\u23ED\uFE0F Skipping ${r.toUpperCase()} patterns (converting from ${this.convertFrom})`,
						);
						return;
					}
					(this.log(`\u{1F50D} Testing currency: ${r}`),
						o.patterns.forEach((n, i) => {
							try {
								let c = e.match(n);
								c
									? ((t = !0),
										this.log(
											`\u2705 Pattern ${r}-${i} matched: ${c[0]}`,
										))
									: this.log(
											`\u274C Pattern ${r}-${i} no match`,
										);
							} catch (c) {
								this.log(
									`\u{1F4A5} Error testing pattern ${r}-${i}: ${c.message}`,
									"error",
								);
							}
						}));
				}),
					t ||
						this.log(
							"\u26A0\uFE0F WARNING: No patterns matched test text!",
						));
				let s = document.querySelectorAll("*").length;
				(this.log(`\u{1F4E6} Total DOM elements: ${s}`),
					$.forEach((r) => {
						try {
							let o = document.querySelectorAll(r);
							this.log(
								`\u{1F3AF} Selector "${r}": ${o.length} elements`,
							);
						} catch (o) {
							this.log(
								`\u{1F4A5} Error with selector "${r}": ${o.message}`,
								"error",
							);
						}
					}));
			} catch (e) {
				(this.log(
					`\u{1F4A5} Error in diagnostics: ${e.message}`,
					"error",
				),
					console.error(
						"\u{1F41B} Diagnostics error stack:",
						e.stack,
					));
			}
		}
		scanForPrices() {
			this.log("\u{1F50D} Starting price scan...");
			let e = performance.now(),
				t = 0;
			this.cleanupBrokenConversions();
			let s = this.findPriceElements();
			this.log(`\u{1F4CB} Found ${s.length} potential price elements`);
			let r = this.sortElementsByHierarchy(s);
			r.forEach((n, i) => {
				(this.log(
					`\u{1F50D} Processing element ${i + 1}/${r.length}: ${n.tagName}.${n.className}`,
				),
					this.debugLog(
						n,
						`\u{1F522} Element ${i + 1}/${r.length} in scan queue`,
					),
					this.processElement(n)
						? (t++,
							this.log(`\u2705 Converted element ${i + 1}`),
							this.debugLog(
								n,
								"\u2705 Successfully converted in scan",
							))
						: (this.log(
								`\u274C No conversion for element ${i + 1}`,
							),
							this.debugLog(n, "\u274C No conversion in scan")));
			});
			let o = performance.now();
			((this.stats.converted += t),
				this.log(
					`\u{1F4CA} Scan complete: ${t} prices converted in ${(o - e).toFixed(2)}ms`,
				),
				this.log(
					`\u{1F4C8} Total stats: ${JSON.stringify(this.stats)}`,
				));
		}
		cleanupBrokenConversions() {
			let e = document.querySelectorAll(
				".currency-converted .currency-converted",
			);
			e.length > 0 &&
				(this.log(
					`\u{1F9F9} Cleaning up ${e.length} broken nested conversions`,
				),
				e.forEach((t) => t.remove()));
		}
		sortElementsByHierarchy(e) {
			return e.sort((t, s) =>
				t.contains(s) ? -1 : s.contains(t) ? 1 : 0,
			);
		}
		findPriceElements() {
			this.log("\u{1F3AF} Finding price elements...");
			let e = new Set();
			($.forEach((r) => {
				try {
					let o = document.querySelectorAll(r);
					(this.log(
						`\u{1F3AF} Selector "${r}": ${o.length} elements`,
					),
						o.forEach((n) => {
							if (this.isInsideIgnoredSelector(n)) {
								this.debugLog(
									n,
									`\u23ED\uFE0F Skipped by selector ${r} (inside ignored selector)`,
								);
								return;
							}
							let i = n.hasAttribute("data-currency-converted"),
								c = n.closest(".currency-converted"),
								a = n.closest("[data-currency-converted]"),
								d = n.innerHTML.includes("currency-converted");
							i || c || a || d
								? this.debugLog(
										n,
										`\u23ED\uFE0F Skipped by selector ${r} (dataAttr=${i}, convertedParent=${!!c}, convertedAttrParent=${!!a}, convertedHTML=${d})`,
									)
								: (e.add(n),
									this.debugLog(
										n,
										`\u2705 Added to processing queue via selector: ${r}`,
									));
						}));
				} catch (o) {
					this.log(
						`\u274C Error with selector "${r}": ${o.message}`,
						"error",
					);
				}
			}),
				this.log("\u{1F50D} Scanning text elements..."));
			let t = document.querySelectorAll(
				"span, div, p, td, li, strong, b, option",
			);
			this.log(`\u{1F4DD} Found ${t.length} text elements to check`);
			let s = 0;
			return (
				t.forEach((r) => {
					if (this.isInsideIgnoredSelector(r)) {
						this.debugLog(
							r,
							"\u23ED\uFE0F Skipped text scan (inside ignored selector)",
						);
						return;
					}
					let o = r.hasAttribute("data-currency-converted"),
						n = r.closest(".currency-converted"),
						i = r.closest("[data-currency-converted]"),
						c = r.querySelector(".currency-converted"),
						a = r.innerHTML.includes("currency-converted");
					if (o || n || i || c || a) {
						this.debugLog(
							r,
							`\u23ED\uFE0F Skipped text scan (dataAttr=${o}, convertedParent=${!!n}, convertedAttrParent=${!!i}, convertedChild=${!!c}, convertedHTML=${a})`,
						);
						return;
					}
					let u = r.textContent || "";
					(this.debugLog(
						r,
						`\u{1F50D} Testing text content for patterns: "${u}"`,
					),
						this.containsPricePatternWithDebug(u, r)
							? (e.add(r),
								s++,
								this.debugLog(
									r,
									"\u2705 Added to processing queue via text scan",
								))
							: this.debugLog(
									r,
									"\u274C Text content has no price patterns",
								));
				}),
				this.log(`\u{1F4B0} Text elements with price patterns: ${s}`),
				this.log(`\u{1F4E6} Total unique price elements: ${e.size}`),
				Array.from(e)
			);
		}
		containsPricePattern(e) {
			if (!e || e.length > 200)
				return (
					e?.length > 200 &&
						this.log(
							`\u23ED\uFE0F Skipping long text (${e.length} chars)`,
						),
					!1
				);
			let t = !1,
				s = [];
			return (
				Object.entries(S).forEach(([r, o]) => {
					r.toLowerCase() === this.convertFrom.toLowerCase() &&
						o.patterns.forEach((n, i) => {
							let c = n.test(e);
							(s.push(`${r}-${i}:${c ? "MATCH" : "NO"}`),
								c &&
									((t = !0),
									g.debugMode &&
										this.log(
											`\u{1F3AF} Pattern match in text: "${e}" -> ${n}`,
										)));
						});
				}),
				(g.debugMode || g.enableLogging) &&
					this.log(
						`\u{1F50D} Pattern test for "${e}": [${s.join(", ")}] -> ${t ? "HAS_PATTERN" : "NO_PATTERN"}`,
					),
				t
			);
		}
		containsPricePatternWithDebug(e, t) {
			if (!e || e.length > 200)
				return (
					e?.length > 200 &&
						(t
							? this.debugLog(
									t,
									`\u23ED\uFE0F Skipping long text (${e.length} chars)`,
								)
							: this.log(
									`\u23ED\uFE0F Skipping long text (${e.length} chars)`,
								)),
					!1
				);
			let s = !1,
				r = [];
			if (
				(Object.entries(S).forEach(([n, i]) => {
					n.toLowerCase() === this.convertFrom.toLowerCase() &&
						i.patterns.forEach((c, a) => {
							let d = c.test(e);
							(r.push(`${n}-${a}:${d ? "MATCH" : "NO"}`),
								d &&
									((s = !0),
									t
										? this.debugLog(
												t,
												`\u{1F3AF} Pattern ${n}-${a} MATCHED: ${c}`,
											)
										: g.debugMode &&
											this.log(
												`\u{1F3AF} Pattern match in text: "${e}" -> ${c}`,
											)));
						});
				}),
				t
					? g.enableLogging ||
						t.hasAttribute("data-debug-currency") ||
						t.closest("[data-debug-currency]")
					: g.debugMode || g.enableLogging)
			) {
				let n = `\u{1F50D} Pattern test for "${e}": [${r.join(", ")}] -> ${s ? "HAS_PATTERN" : "NO_PATTERN"}`;
				t ? this.debugLog(t, n) : this.log(n);
			}
			return s;
		}
		processElement(e) {
			try {
				if (
					(this.debugLog(e, "\u{1F50D} Starting processElement"),
					this.isInsideIgnoredSelector(e))
				)
					return (
						this.debugLog(
							e,
							"\u23ED\uFE0F Skipping element inside ignored selector",
						),
						!1
					);
				let t = e.outerHTML.toLowerCase(),
					s = e.className.toLowerCase().includes("boost"),
					r = t.includes("boost-sd"),
					o = e.className.toLowerCase().includes("quantity-break"),
					n = t.includes("quantity-break"),
					i = e.hasAttribute("data-essential-upsell-element"),
					c = t.includes("data-essential-upsell-element"),
					a = e.classList.contains("productView-price"),
					d = s || r,
					u = o || n,
					l = i || c,
					m = a;
				return d
					? (this.log(
							`\u23F1\uFE0F Detected boost element (class: ${s}, HTML: ${r}), waiting for 2500ms. Element: ${e.outerHTML.substring(0, 200)}...`,
						),
						this.debugLog(
							e,
							"\u23F1\uFE0F Boost element detected, applying 2500ms delay",
						),
						e.hasAttribute("data-currency-converted") &&
							(e.removeAttribute("data-currency-converted"),
							this.processedElements.delete(e)),
						setTimeout(() => {
							(this.log(
								"\u23F1\uFE0F Processing boost element after 2500ms delay",
							),
								this.processElementCore(e));
						}, 2500),
						!1)
					: u
						? (this.log(
								`\u23F1\uFE0F Detected quantity-break element (class: ${o}, HTML: ${n}), waiting for 250ms. Element: ${e.outerHTML.substring(0, 200)}...`,
							),
							this.debugLog(
								e,
								"\u23F1\uFE0F Quantity-break element detected, applying 250ms delay",
							),
							e.hasAttribute("data-currency-converted") &&
								(e.removeAttribute("data-currency-converted"),
								this.processedElements.delete(e)),
							setTimeout(() => {
								(this.log(
									"\u23F1\uFE0F Processing quantity-break element after 250ms delay",
								),
									this.processElementCore(e));
							}, 250),
							!1)
						: l
							? (this.log(
									`\u23F1\uFE0F Detected essential-upsell element (attr: ${i}, HTML: ${c}), waiting for 3000ms. Element: ${e.outerHTML.substring(0, 200)}...`,
								),
								this.debugLog(
									e,
									"\u23F1\uFE0F Essential-upsell element detected, applying 3000ms delay",
								),
								e.hasAttribute("data-currency-converted") &&
									(e.removeAttribute(
										"data-currency-converted",
									),
									this.processedElements.delete(e)),
								setTimeout(() => {
									(this.log(
										"\u23F1\uFE0F Processing essential-upsell element after 3000ms delay",
									),
										this.processElementCore(e));
								}, 3e3),
								!1)
							: m
								? (this.log(
										`\u23F1\uFE0F Detected productView-price element, waiting for 500ms. Element: ${e.outerHTML.substring(0, 200)}...`,
									),
									this.debugLog(
										e,
										"\u23F1\uFE0F productView-price element detected, applying 500ms delay",
									),
									e.hasAttribute("data-currency-converted") &&
										(e.removeAttribute(
											"data-currency-converted",
										),
										this.processedElements.delete(e)),
									setTimeout(() => {
										(this.log(
											"\u23F1\uFE0F Processing productView-price element after 500ms delay",
										),
											this.processElementCore(e));
									}, 500),
									!1)
								: this.processElementCore(e);
			} catch (t) {
				return (
					this.stats.errors++,
					this.log(
						`\u{1F4A5} Error processing element: ${t.message}`,
						"error",
					),
					this.log(`\u{1F41B} Stack: ${t.stack}`, "error"),
					!1
				);
			}
		}
		processElementCore(e) {
			try {
				if (
					(this.debugLog(e, "\u{1F50D} Starting processElementCore"),
					this.useCssMode && e.closest("#CartDrawer"))
				)
					return this.processElementCssMode(e);
				if (this.shouldUseSiblingMode(e))
					return this.processElementSiblingMode(e);
				let t = this.findSiblingModeChildren(e);
				if (t.length > 0) {
					this.log(
						`\u{1F46B} Found ${t.length} sibling mode children, processing them instead of parent`,
					);
					let E = !1;
					if (
						(t.forEach((P) => {
							this.processElementSiblingMode(P) && (E = !0);
						}),
						E)
					)
						return (
							e.setAttribute("data-currency-converted", "true"),
							this.processedElements.add(e),
							!0
						);
				}
				if (
					e.getAttribute("data-essential-upsell-element") ===
					"regular-price"
				) {
					if (
						(this.debugLog(
							e,
							"\u{1F48E} Essential Upsells regular-price detected, using special handling",
						),
						e.hasAttribute("data-currency-converted") ||
							e.innerHTML.includes("currency-converted"))
					)
						return (
							this.debugLog(
								e,
								"\u23ED\uFE0F Essential Upsells element already converted",
							),
							!1
						);
					let E = e.innerHTML,
						P = e.textContent || "",
						B =
							this.convertFrom === "BGN"
								? "(\u043B\u0432|BGN)"
								: "(\u20AC|EUR|\u0435\u0432\u0440\u043E)",
						I = new RegExp(`([\\d,]+\\.?\\d*)\\s*${B}`, "i"),
						R = P.match(I);
					if (R) {
						let k = R[1].replace(",", ""),
							T = parseFloat(k);
						if (!isNaN(T) && T > 0) {
							let F = p.convertCurrency(T, this.convertFrom),
								_ = p.formatNumber(F),
								O =
									this.convertTo === "EUR"
										? "\u20AC"
										: "\u043B\u0432";
							return (
								(e.innerHTML =
									E +
									` <span class="currency-converted">(${_} ${O})</span>`),
								e.setAttribute(
									"data-currency-converted",
									"true",
								),
								this.stats.converted++,
								this.processedElements.add(e),
								this.convertedElements.add(e),
								this.log(
									`\u2705 Essential Upsells: Converted ${T} ${this.convertFrom} \u2192 ${_} ${this.convertTo}`,
								),
								this.debugLog(
									e,
									"\u2705 Essential Upsells conversion complete",
								),
								!0
							);
						}
					}
					return (
						this.debugLog(
							e,
							"\u274C No valid price found in Essential Upsells element",
						),
						!1
					);
				}
				let s = e.hasAttribute("data-currency-converted"),
					r = e.innerHTML.includes("currency-converted"),
					o = !1,
					i =
						!(
							e.classList.contains("tpo_additional-price") ||
							e.closest(".tpo_option_type_label")
						) && e.textContent?.match(/\(\s*\d+[\d,.\s]*\s*[€лв]/),
					c = e.querySelector(".currency-converted"),
					a = e.closest(".currency-converted"),
					d = e.closest("[data-currency-converted]"),
					u =
						e.parentElement?.querySelector(".currency-converted") &&
						!e.textContent?.match(
							/[\d,.]+ (лв|BGN|EUR|€)|€\s*[\d,.]+/,
						),
					l = this.processedElements.has(e),
					h =
						e.textContent?.match(
							/[\d,.]+ (лв|BGN|EUR|€)|€\s*[\d,.]+/,
						) &&
						!r &&
						!c &&
						!e.textContent?.includes("\u20AC)"),
					v = s && h;
				if (
					(this.debugLog(
						e,
						`\u{1F50D} Duplicate checks: dataAttr=${s}, convertedHTML=${r}, tildeText=${o}, convertedPattern=${!!i}, convertedChild=${!!c}, convertedParent=${!!a}, convertedAttrParent=${!!d}, siblingConverted=${!!u}, inProcessedSet=${l}, needsReprocessing=${v}`,
					),
					v &&
						(this.debugLog(
							e,
							"\u{1F504} Element content was replaced, needs reprocessing",
						),
						this.processedElements.delete(e)),
					l || ((s || r || c || o || i || a || u) && !v))
				)
					return (
						this.debugLog(
							e,
							`\u23ED\uFE0F Skipping already processed/converted element (reason: ${l ? "in processed set" : "has existing conversion"})`,
						),
						!1
					);
				let N = e.textContent || "",
					f = e.innerHTML;
				(this.debugLog(e, "\u{1F504} Processing element"),
					this.debugLog(e, `\u{1F4DD} Text: "${N}"`),
					this.debugLog(e, `\u{1F4C4} HTML: "${f}"`));
				let C = e.querySelectorAll($.join(","));
				C.length > 0 &&
					(this.debugLog(
						e,
						`\u{1F476} Element has ${C.length} child price elements, processing parent only`,
					),
					C.forEach((E) => {
						(this.processedElements.add(E),
							this.debugLog(
								E,
								"\u{1F476} Marked as processed (child of parent being processed)",
							));
					}));
				let w = this.convertPricesInHTML(f);
				if (w !== f)
					return (
						this.debugLog(e, "\u2705 Conversion found!"),
						this.debugLog(e, `\u{1F4E5} Original HTML: "${f}"`),
						(e.innerHTML = w),
						e.setAttribute("data-currency-converted", "true"),
						this.processedElements.add(e),
						this.convertedElements.add(e),
						e.matches(".sticky-price") &&
							this.debugTargetSelector === ".sticky-price" &&
							console.log(
								"[STICKY-PRICE DEBUG] Element converted and added to tracking:",
								{
									element: e,
									convertedElementsSize:
										this.convertedElements.size,
									hasElement: this.convertedElements.has(e),
								},
							),
						this.debugLog(
							e,
							`\u{1F4E4} Updated HTML: "${e.innerHTML}"`,
						),
						this.debugLog(
							e,
							"\u2705 Element updated successfully and marked as converted",
						),
						!0
					);
				this.debugLog(
					e,
					"\u274C No price conversion needed for this element",
				);
			} catch (t) {
				(this.stats.errors++,
					this.log(
						`\u{1F4A5} Error processing element: ${t.message}`,
						"error",
					),
					this.log(`\u{1F41B} Stack: ${t.stack}`, "error"));
			}
			return !1;
		}
		processElementCssMode(e) {
			try {
				if (
					(this.debugLog(
						e,
						"\u{1F3A8} CSS mode: Starting processElementCssMode",
					),
					e.hasAttribute("data-converted-price"))
				)
					return (
						this.debugLog(
							e,
							"\u23ED\uFE0F CSS mode: Already has data-converted-price",
						),
						!1
					);
				if (e.closest("[data-converted-price]"))
					return (
						this.debugLog(
							e,
							"\u23ED\uFE0F CSS mode: Parent already has data-converted-price",
						),
						!1
					);
				if (this.processedElements.has(e))
					return (
						this.debugLog(
							e,
							"\u23ED\uFE0F CSS mode: Already in processed set",
						),
						!1
					);
				let t = e.textContent || "";
				if (t.length > 200)
					return (
						this.debugLog(
							e,
							`\u23ED\uFE0F CSS mode: Text too long (${t.length} chars)`,
						),
						!1
					);
				let s =
						this.convertFrom === "BGN"
							? "(\u043B\u0432\\.?|BGN)"
							: "(\u20AC|EUR|\u0435\u0432\u0440\u043E)",
					r =
						this.convertFrom === "BGN"
							? new RegExp(
									`([\\d\\s,]+(?:[.,]\\d{1,2})?)\\s*${s}`,
									"i",
								)
							: new RegExp(
									`${s}\\s*([\\d\\s,]+(?:[.,]\\d{1,2})?)`,
									"i",
								),
					o = t.match(r);
				if (!o)
					return (
						this.debugLog(
							e,
							`\u274C CSS mode: No price match in "${t}"`,
						),
						!1
					);
				let n = e.querySelectorAll("*");
				for (let m of n) {
					let h = m.textContent || "";
					if (r.test(h) && h.length < t.length)
						return (
							this.debugLog(
								e,
								"\u23ED\uFE0F CSS mode: Child element contains price, skipping container",
							),
							!1
						);
				}
				let i = this.convertFrom === "BGN" ? o[1] : o[2],
					c = p.parseNumber(i.trim());
				if (isNaN(c) || c <= 0)
					return (
						this.debugLog(
							e,
							`\u274C CSS mode: Invalid price parsed: ${c} from "${i}"`,
						),
						!1
					);
				let a = p.convertCurrency(c, this.convertFrom),
					d = p.formatNumber(a),
					u = this.convertTo === "EUR" ? "\u20AC" : "\u043B\u0432",
					l = `${d} ${u}`;
				return (
					e.setAttribute("data-converted-price", l),
					e.setAttribute("data-original-price", String(c)),
					e.setAttribute("data-currency-converted", "true"),
					this.stats.converted++,
					this.processedElements.add(e),
					this.convertedElements.add(e),
					this.log(
						`\u2705 CSS mode: Converted ${c} ${this.convertFrom} \u2192 ${d} ${this.convertTo}`,
					),
					this.debugLog(
						e,
						`\u2705 CSS mode: Set data-converted-price="${l}"`,
					),
					!0
				);
			} catch (t) {
				return (
					this.stats.errors++,
					this.log(`\u{1F4A5} CSS mode error: ${t.message}`, "error"),
					!1
				);
			}
		}
		isInsideIgnoredSelector(e) {
			return g.ignoredSelectors.some((t) => {
				try {
					return e.matches(t) || e.closest(t) !== null;
				} catch {
					return !1;
				}
			});
		}
		shouldUseSiblingMode(e) {
			let t = g.siblingModeSelectors.some((s) => {
				try {
					let r = e.matches(s);
					return (
						r &&
							this.log(
								`\u{1F46B} Sibling mode: Element matches selector "${s}"`,
							),
						r
					);
				} catch {
					return !1;
				}
			});
			return (
				!t &&
					g.siblingModeSelectors.length > 0 &&
					g.siblingModeSelectors.some((r) => {
						try {
							return e.querySelector(r) !== null;
						} catch {
							return !1;
						}
					}) &&
					this.log(
						`\u26A0\uFE0F Element CONTAINS sibling mode targets but is not one itself: ${e.tagName}.${e.className}`,
					),
				t
			);
		}
		findSiblingModeChildren(e) {
			let t = [];
			return (
				g.siblingModeSelectors.forEach((s) => {
					try {
						e.querySelectorAll(s).forEach((o) => {
							!o.hasAttribute("data-currency-converted") &&
								!o.nextElementSibling?.classList.contains(
									"currency-converted",
								) &&
								t.push(o);
						});
					} catch {}
				}),
				t
			);
		}
		processElementSiblingMode(e) {
			try {
				if (
					(this.debugLog(
						e,
						"\u{1F46B} Sibling mode: Starting processElementSiblingMode",
					),
					e.nextElementSibling?.classList.contains(
						"currency-converted",
					))
				)
					return (
						this.debugLog(
							e,
							"\u23ED\uFE0F Sibling mode: Already has sibling conversion",
						),
						!1
					);
				if (
					e.hasAttribute("data-currency-converted") ||
					this.processedElements.has(e)
				)
					return (
						this.debugLog(
							e,
							"\u23ED\uFE0F Sibling mode: Already processed",
						),
						!1
					);
				let s = e.textContent || "";
				if (s.length > 200)
					return (
						this.debugLog(
							e,
							`\u23ED\uFE0F Sibling mode: Text too long (${s.length} chars)`,
						),
						!1
					);
				let r =
						this.convertFrom === "BGN"
							? "(\u043B\u0432\\.?|BGN)"
							: "(\u20AC|EUR|\u0435\u0432\u0440\u043E)",
					o =
						this.convertFrom === "BGN"
							? new RegExp(
									`([\\d\\s,]+(?:[.,]\\d{1,2})?)\\s*${r}`,
									"i",
								)
							: new RegExp(
									`${r}\\s*([\\d\\s,]+(?:[.,]\\d{1,2})?)`,
									"i",
								),
					n = s.match(o);
				if (!n)
					return (
						this.debugLog(
							e,
							`\u274C Sibling mode: No price match in "${s}"`,
						),
						!1
					);
				let i = this.convertFrom === "BGN" ? n[1] : n[2],
					c = p.parseNumber(i.trim());
				if (isNaN(c) || c <= 0)
					return (
						this.debugLog(
							e,
							`\u274C Sibling mode: Invalid price parsed: ${c} from "${i}"`,
						),
						!1
					);
				let a = p.convertCurrency(c, this.convertFrom),
					d = p.formatNumber(a),
					u = this.convertTo === "EUR" ? "\u20AC" : "\u043B\u0432",
					l = document.createElement("span");
				return (
					(l.className = "currency-converted"),
					(l.textContent = ` (${d} ${u})`),
					e.insertAdjacentElement("afterend", l),
					e.setAttribute("data-currency-converted", "true"),
					e.setAttribute("data-original-price", String(c)),
					e.setAttribute("data-sibling-mode", "true"),
					this.stats.converted++,
					this.processedElements.add(e),
					this.convertedElements.add(e),
					this.log(
						`\u2705 Sibling mode: Converted ${c} ${this.convertFrom} \u2192 ${d} ${this.convertTo}`,
					),
					this.debugLog(
						e,
						"\u2705 Sibling mode: Inserted sibling span after element",
					),
					!0
				);
			} catch (t) {
				return (
					this.stats.errors++,
					this.log(
						`\u{1F4A5} Sibling mode error: ${t.message}`,
						"error",
					),
					!1
				);
			}
		}
		convertPricesInText(e) {
			let t = this.convertTo === "EUR" ? "\u20AC" : "\u043B\u0432",
				s = new RegExp(
					`\\(\\s*\\d+[\\d,.\\s]*\\s*${t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`,
				);
			if (e.includes("currency-converted") || s.test(e))
				return (
					this.log("\u23ED\uFE0F Skipping already converted text"),
					e
				);
			let r = e;
			this.log(`\u{1F504} Converting text: "${e}"`);
			let o = [];
			return (
				Object.entries(S).forEach(([n, i]) => {
					n.toLowerCase() === this.convertFrom.toLowerCase() &&
						i.patterns.forEach((c, a) => {
							let d,
								u = new RegExp(
									c.source,
									c.flags.includes("g")
										? c.flags
										: c.flags + "g",
								);
							for (; (d = u.exec(r)) !== null; ) {
								let l = d[0],
									m = d.index,
									h = m + l.length,
									v = o.filter(
										(b) =>
											(m >= b.start && m < b.end) ||
											(h > b.start && h <= b.end) ||
											(m <= b.start && h >= b.end),
									);
								if (v.length === 0)
									o.push({
										match: l,
										start: m,
										end: h,
										currencyCode: n,
										patternIndex: a,
										groups: Array.from(d).slice(1),
									});
								else {
									let b = v.every(
											(f) => l.length > f.match.length,
										),
										A = l.includes("<sup>"),
										N = v.some((f) =>
											f.match.includes("<sup>"),
										);
									((A && !N) || b) &&
										(v.forEach((f) => {
											let C = o.indexOf(f);
											C > -1 && o.splice(C, 1);
										}),
										o.push({
											match: l,
											start: m,
											end: h,
											currencyCode: n,
											patternIndex: a,
											groups: Array.from(d).slice(1),
										}));
								}
							}
						});
				}),
				o.sort((n, i) => i.start - n.start),
				o.forEach((n) => {
					let {
						match: i,
						currencyCode: c,
						patternIndex: a,
						groups: d,
					} = n;
					(this.log(`\u{1F3AF} Pattern ${c}-${a} matched: "${i}"`),
						this.log(
							`\u{1F4CA} Groups: ${JSON.stringify(d.slice(0, 4))}`,
						));
					let u = S[c],
						l;
					if (
						d.length >= 3 &&
						d[0] &&
						/^\d+$/.test(d[0]) &&
						d[1] &&
						/^\d{1,2}$/.test(d[1]) &&
						d[2] &&
						u.symbols.some((h) =>
							d[2].toLowerCase().includes(h.toLowerCase()),
						)
					)
						((l = p.parseNumber(d[0], d[1])),
							this.log(
								`\u{1F4B0} Parsed decimal/superscript amount: ${d[0]}.${d[1]} -> ${l}`,
							));
					else {
						let h = d.find(
							(v) =>
								v &&
								/\d/.test(v) &&
								!u.symbols.some((b) =>
									v.toLowerCase().includes(b.toLowerCase()),
								),
						);
						h &&
							((l = p.parseNumber(h)),
							this.log(
								`\u{1F4B0} Parsed standard amount: ${h} -> ${l}`,
							));
					}
					if (!isNaN(l) && l > 0) {
						let h = p.convertCurrency(l, this.convertFrom);
						this.log(
							`\u{1F504} Converted ${l} ${this.convertFrom} -> ${h} ${this.convertTo}`,
						);
						let v = p.createConvertedDisplay(l, h, this.convertTo);
						(this.log(`\u{1F3A8} Display HTML: ${v}`),
							(n.convertedDisplay = v));
					} else this.log(`\u274C Invalid amount: ${l}`);
				}),
				o.forEach((n) => {
					if (n.convertedDisplay) {
						let i = r.substring(0, n.start),
							c = r.substring(n.end);
						((r = i + n.match + n.convertedDisplay + c),
							this.log(
								`\u2705 Applied conversion at position ${n.start}`,
							));
					}
				}),
				r !== e
					? this.log(`\u2705 Final result: "${r}"`)
					: this.log("\u274C No changes made to text"),
				r
			);
		}
		convertPricesInHTML(e) {
			this.log(`\u{1F504} Converting HTML: "${e}"`);
			let t = [],
				s = e,
				r = 0;
			s = s.replace(
				/<span[^>]*class="[^"]*currency-converted[^"]*"[^>]*>.*?<\/span>/gi,
				(c) => {
					let a = `__CONV_${r}__`;
					return (t.push({ placeholder: a, original: c }), r++, a);
				},
			);
			let o = [],
				n = 0;
			((s = s.replace(
				/(\w+)="([^"]*(?:лв|BGN|EUR|€)[^"]*)"/g,
				(c, a, d) => {
					let u = `__ATTR_${n}__`;
					return (o.push({ placeholder: u, original: c }), n++, u);
				},
			)),
				(s = s.replace(
					/(\w+)='([^']*(?:лв|BGN|EUR|€)[^']*)'/g,
					(c, a, d) => {
						let u = `__ATTR_${n}__`;
						return (
							o.push({ placeholder: u, original: c }),
							n++,
							u
						);
					},
				)));
			let i = this.convertPricesInText(s);
			return (
				o.forEach(({ placeholder: c, original: a }) => {
					i = i.replace(c, a);
				}),
				t.forEach(({ placeholder: c, original: a }) => {
					i = i.replace(c, a);
				}),
				i !== e &&
					(this.log("\u2705 HTML conversion successful"),
					this.log(`\u{1F4E4} Result: "${i}"`)),
				i
			);
		}
		setupObservers() {
			let e = new IntersectionObserver(
				x((t) => {
					t.forEach((s) => {
						s.isIntersecting && this.processElement(s.target);
					});
				}, 100),
			);
			((this.observer = new MutationObserver(
				M((t) => {
					let s = [];
					(t.forEach((r) => {
						if (r.type === "childList") {
							let o = r.target;
							if (o.nodeType === Node.ELEMENT_NODE) {
								let n = o.hasAttribute(
										"data-currency-converted",
									),
									i =
										o.querySelector(
											".currency-converted",
										) !== null,
									c =
										this.containsPricePattern(
											o.textContent || "",
										) || $.some((a) => o.matches(a));
								if (
									(n &&
										!i &&
										c &&
										(this.debugLog(
											o,
											"\u{1F504} Detected element lost conversion, marking for reprocessing",
										),
										o.removeAttribute(
											"data-currency-converted",
										),
										this.processedElements.delete(o),
										s.push(o)),
									o.tagName === "TEXT-COMPONENT")
								) {
									let a =
											o.innerHTML.includes(
												"currency-converted",
											),
										d = this.containsPricePattern(
											o.textContent || "",
										);
									!a &&
										d &&
										(this.debugLog(
											o,
											"\u{1F6D2} Cart text-component needs processing",
										),
										o.removeAttribute(
											"data-currency-converted",
										),
										this.processedElements.delete(o),
										s.push(o));
								}
							}
							if (
								(r.addedNodes.length > 0 &&
									r.addedNodes.forEach((n) => {
										if (n.nodeType === Node.ELEMENT_NODE) {
											let i = n;
											if (
												i.classList.contains(
													"cart-items__table-row",
												) ||
												i.closest(
													".cart-items__table-row",
												)
											) {
												let a = i.classList.contains(
													"cart-items__table-row",
												)
													? i
													: i.closest(
															".cart-items__table-row",
														);
												a &&
													a
														.querySelectorAll(
															".cart-items__price, text-component, .cart-items__details",
														)
															.forEach((u) => {
																(u.removeAttribute(
																	"data-currency-converted",
																),
																	this.processedElements.delete(
																		u,
																	),
																	s.push(u),
																	this.debugLog(
																		u,
																		"\u{1F6D2} Cart element marked for reprocessing",
																	));
															});
												}
											let c = [
												i,
												...Array.from(
													i.querySelectorAll("*"),
												),
											].filter((a) => {
												let d =
														$.some(
															(l) =>
																a.matches &&
																a.matches(l),
														) ||
														this.containsPricePattern(
															a.textContent || "",
														),
													u =
														this.processedElements.has(
															a,
														) ||
														a.hasAttribute(
															"data-currency-converted",
														) ||
														a.innerHTML.includes(
															"currency-converted",
														) ||
														a.closest(
															".currency-converted",
														) ||
														a.closest(
															"[data-currency-converted]",
														);
												return d && !u;
											});
											s.push(...c);
										}
									}),
								r.type === "childList")
							) {
								let i = r.target.closest?.(
									'[id^="block-title-price-"].product__price[data-updatable]',
								);
								i &&
									i
										.querySelectorAll(".money.price-item")
										.forEach((a) => {
											let d =
												a.innerHTML.includes(
													"currency-converted",
												) ||
												a.querySelector(
													".currency-converted",
												);
											if (
												this.containsPricePattern(
													a.textContent || "",
												) &&
												!d
											) {
												(this.debugLog(
													a,
													"\u{1F504} Variant price changed, reprocessing",
												),
													a.removeAttribute(
														"data-currency-converted",
													),
													this.processedElements.delete(
														a,
													));
												let l = a.closest(
													"[data-currency-converted]",
												);
												(l &&
													(l.removeAttribute(
														"data-currency-converted",
													),
													this.processedElements.delete(
														l,
													)),
													s.includes(a) || s.push(a));
											}
										});
							}
						}
					}),
						s.length > 0 &&
							(this.log(
								`\u{1F195} Processing ${s.length} new elements from mutations`,
							),
							s.forEach((r, o) => {
								this.debugLog(
									r,
									`\u{1F195} Mutation element ${o + 1}/${s.length}`,
								);
								let n = this.processElement(r);
								this.debugLog(
									r,
									`\u{1F195} Mutation processing result: ${n ? "converted" : "no conversion"}`,
								);
							})));
				}, g.updateDelay),
			)),
				this.observer.observe(document.body, {
					childList: !0,
					subtree: !0,
					characterData: !1,
					attributes: !1,
				}),
				this.setupMainInterval());
		}
		setupMainInterval() {
			let e = g.scanInterval;
			this.log(
				`\u23F0 Setting up combined scan & recheck interval every ${e}ms`,
			);
			let t = 0;
			((this.mainInterval = window.setInterval(() => {
				(this.recheckConvertedElements(),
					t % 2 === 0 &&
						(this.log("\u{1F504} Running interval scan..."),
						this.scanForPrices()),
					t++);
			}, e)),
				this.setupTPOInterval());
		}
		setupTPOInterval() {
			this.log("\u{1F3AF} Setting up TPO-specific element watcher");
			let e = () => {
					let s = document.querySelectorAll(".tpo_product_price"),
						r = 0;
					(s.forEach((o) => {
						let n = o.querySelector(".currency-converted") !== null,
							i = o.innerHTML.includes("currency-converted");
						if (
							o.textContent?.match(/[\d,.]+ (лв|BGN)/) &&
							!n &&
							!i
						) {
							this.debugLog(
								o,
								"\u{1F3AF} TPO element found without conversion, processing...",
							);
							let a = o.closest("[data-currency-converted]");
							(a &&
								(a.removeAttribute("data-currency-converted"),
								this.processedElements.delete(a)),
								this.processedElements.delete(o),
								this.processElement(o) && r++);
						}
					}),
						r > 0 &&
							this.log(
								`\u{1F3AF} TPO interval: Processed ${r} TPO elements`,
							));
				},
				t = setInterval(e, 250);
			setTimeout(() => {
				(clearInterval(t),
					this.log(
						"\u{1F3AF} TPO watcher: Switching to normal speed (1s intervals)",
					),
					setInterval(e, 1e3));
			}, 5e3);
		}
		hasUnconvertedPrices(e) {
			let t = e.innerHTML,
				s =
					this.convertFrom === "BGN"
						? /(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)\s*(лв\.?|лева|лев|BGN)/gi
						: /(€)\s*(\d+(?:[\s,.]?\d{3})*(?:[,.]?\d{1,2})?)/gi,
					r;
			for (; (r = s.exec(t)) !== null; ) {
				let o = r.index + r[0].length,
					n = t.substring(o, o + 100);
				if (!/^\s*<span[^>]*class="[^"]*currency-converted/.test(n))
					return (
						this.debugLog(
							e,
							`\u{1F50D} Found unconverted price: "${r[0]}"`,
						),
						!0
					);
			}
			return !1;
		}
		recheckConvertedElements() {
			if (this.convertedElements.size === 0) return;
			this.debugTargetSelector === ".sticky-price" &&
				Array.from(this.convertedElements).some((s) =>
					s.matches(".sticky-price"),
				) &&
				console.log(
					"[STICKY-PRICE DEBUG] Periodic check running, convertedElements size:",
					this.convertedElements.size,
				);
			let e = [];
			(this.convertedElements.forEach((t) => {
				if (!document.contains(t)) {
					(this.convertedElements.delete(t),
						this.processedElements.delete(t));
					return;
				}
				let s = t.hasAttribute("data-currency-converted"),
					r = t.textContent || "";
				if (this.useCssMode) {
					let n = t.hasAttribute("data-converted-price"),
						i = t.getAttribute("data-original-price");
					if (n && i) {
						let c =
								this.convertFrom === "BGN"
									? "(\u043B\u0432\\.?|BGN)"
									: "(\u20AC|EUR|\u0435\u0432\u0440\u043E)",
							a =
								this.convertFrom === "BGN"
									? new RegExp(
											`([\\d\\s,]+(?:[.,]\\d{1,2})?)\\s*${c}`,
											"i",
									)
									: new RegExp(
											`${c}\\s*([\\d\\s,]+(?:[.,]\\d{1,2})?)`,
											"i",
									),
							d = r.match(a);
						if (d) {
							let u = this.convertFrom === "BGN" ? d[1] : d[2],
								l = p.parseNumber(u.trim());
							!isNaN(l) &&
								Math.abs(l - parseFloat(i)) > 0.01 &&
								(this.debugLog(
									t,
									`\u{1F504} CSS mode: Price changed from ${i} to ${l}`,
								),
								e.push(t));
						}
					}
					return;
				}
				if (t.hasAttribute("data-sibling-mode")) {
					let n = t.getAttribute("data-original-price");
					if (n) {
						let i =
								this.convertFrom === "BGN"
									? "(\u043B\u0432\\.?|BGN)"
									: "(\u20AC|EUR|\u0435\u0432\u0440\u043E)",
							c =
								this.convertFrom === "BGN"
									? new RegExp(
											`([\\d\\s,]+(?:[.,]\\d{1,2})?)\\s*${i}`,
											"i",
									)
									: new RegExp(
											`${i}\\s*([\\d\\s,]+(?:[.,]\\d{1,2})?)`,
											"i",
									),
							a = r.match(c);
						if (a) {
							let d = this.convertFrom === "BGN" ? a[1] : a[2],
								u = p.parseNumber(d.trim());
							if (
								!isNaN(u) &&
								Math.abs(u - parseFloat(n)) > 0.01
							) {
								this.debugLog(
									t,
									`\u{1F504} Sibling mode: Price changed from ${n} to ${u}`,
								);
								let l = t.nextElementSibling;
								(l?.classList.contains("currency-converted") &&
									l.remove(),
									e.push(t));
							}
						}
					}
					return;
				}
					let o = this.hasUnconvertedPrices(t);
					if (
						t.matches(".sticky-price") &&
						this.debugTargetSelector === ".sticky-price"
					) {
						console.log("[STICKY-PRICE DEBUG] Periodic check:", {
							element: t,
							hasDataAttr: s,
							hasUnconvertedPrices: o,
							textContent: r.substring(0, 100) + "...",
						});
					}
					if (s && o) {
						this.debugLog(
							t,
							"\u{1F504} Periodic check: Element has unconverted prices, marking for reprocessing",
						);
						e.push(t);
						if (
							t.matches(".sticky-price") &&
							this.debugTargetSelector === ".sticky-price"
						) {
							console.log("[STICKY-PRICE DEBUG] Marked for reprocessing!");
						}
					}
				}),
				e.length > 0 &&
					(this.log(
						`\u{1F504} Periodic recheck found ${e.length} elements needing reprocessing`,
					),
					e.forEach((t) => {
						(t.removeAttribute("data-currency-converted"),
							t.removeAttribute("data-converted-price"),
							t.removeAttribute("data-original-price"),
							t.removeAttribute("data-sibling-mode"),
							this.processedElements.delete(t),
							this.convertedElements.delete(t),
							this.processElement(t));
					})));
		}
		setupAPI() {
			window.CurrencyConverter = {
				refresh: () => this.scanForPrices(),
				getStats: () => ({ ...this.stats }),
				destroy: () => this.destroy(),
				cleanup: () => this.cleanup(),
				version: "2.0.0",
				processElement: (e) => this.processElement(e),
			};
		}
		cleanup() {
			this.log("\u{1F9F9} Cleaning up existing conversions...");
			let e = document.querySelectorAll(".currency-converted");
			(this.log(
				`\u{1F5D1}\uFE0F Found ${e.length} existing conversions to remove`,
			),
				e.forEach((o) => o.remove()));
			let t = document.querySelectorAll("[data-currency-converted]");
			(this.log(
				`\u{1F3F7}\uFE0F Found ${t.length} elements with currency-converted attributes`,
			),
				t.forEach((o) => o.removeAttribute("data-currency-converted")));
			let s = document.querySelectorAll("[data-converted-price]");
			(this.log(
				`\u{1F3A8} Found ${s.length} elements with CSS mode attributes`,
			),
				s.forEach((o) => {
					(o.removeAttribute("data-converted-price"),
						o.removeAttribute("data-original-price"));
				}));
			let r = document.querySelectorAll("[data-sibling-mode]");
			(this.log(
				`\u{1F46B} Found ${r.length} elements with sibling mode attributes`,
			),
				r.forEach((o) => {
					(o.removeAttribute("data-sibling-mode"),
						o.removeAttribute("data-original-price"));
				}),
				this.processedElements.clear(),
				this.convertedElements.clear(),
				this.log("\u2705 Cleanup completed"));
		}
		destroy() {
			(this.observer &&
				(this.observer.disconnect(), (this.observer = null)),
				this.mainInterval &&
					(clearInterval(this.mainInterval),
					(this.mainInterval = null),
					this.log("\u23F0 Cleared main interval")),
				this.cleanup(),
				(window.CurrencyConverterActive = !1),
				delete window.CurrencyConverter,
				this.log("Currency Converter destroyed"));
		}
		log(e, t = "info") {
			g.enableLogging && console[t](`[CurrencyConverter] ${e}`);
		}
		debugLog(e, t, s = "info") {
			let r =
				g.debugSelectors.length > 0 &&
				g.debugSelectors.some((n) => {
					try {
						return e.matches(n) || e.closest(n);
					} catch {
						return !1;
					}
				});
			if (
				this.debugTargetSelector &&
				!e.matches(this.debugTargetSelector) &&
				!e.closest(this.debugTargetSelector)
			)
				return;
			if (
				r ||
				this.debugTargetSelector ||
				(g.enableLogging && g.debugSelectors.length === 0) ||
				e.hasAttribute("data-debug-currency") ||
				e.closest("[data-debug-currency]")
			) {
				let n = `${e.tagName}${e.id ? "#" + e.id : ""}${e.className ? "." + e.className.split(" ").join(".") : ""}`;
				console[s](`[CurrencyConverter] [${n}] ${t}`);
			}
		}
	};
	(() => {
		"use strict";
		if (window.CurrencyConverterActive) return;
		((window.CurrencyConverterActive = !0),
			(() => {
				let e = !!window.DEBUG_CURRENCY_CONVERTER;
				e &&
					(console.log("\u{1F680} Currency Converter script loaded!"),
					console.log(
						"\u{1F4C4} Document state:",
						document.readyState,
					));
				let n = window.CURRENCY_CONVERTER_CONTEXT || {},
					t = window.Shopify?.country || n.country,
					s = window.Shopify?.currency?.active || n.currency,
					r = (window.Shopify?.locale || n.locale || document.documentElement?.lang || "").toLowerCase(),
					o = r.split("-")[0];
					if (e) {
						console.log("\u{1F30D} Shopify country:", t);
						console.log("\u{1F4B0} Shopify currency:", s);
						console.log("\u{1F5E3}\uFE0F Shopify locale:", r);
					}
				if (t !== "BG") {
					e &&
						console.log(
							"\u23ED\uFE0F Not a Bulgarian customer, skipping currency conversion",
						);
					return;
				}
				if (o !== "bg") {
					e &&
						console.log(
							`\u23ED\uFE0F Locale is ${r}, not Bulgarian, skipping currency conversion`,
						);
					return;
				}
				if (s !== "BGN" && s !== "EUR") {
					e &&
						console.log(
							`\u23ED\uFE0F Currency is ${s}, not BGN or EUR, skipping`,
						);
					return;
				}
				((window.CURRENCY_CONVERT_FROM = s),
					(window.CURRENCY_CONVERT_TO = s === "BGN" ? "EUR" : "BGN"));
				let i = window.Shopify?.theme?.theme_store_id,
					c = i === 857;
					(window.CURRENCY_USE_CSS_MODE = c),
						e &&
							(console.log(
								`\u{1F504} Will convert from ${s} to ${window.CURRENCY_CONVERT_TO}`,
							),
							console.log(
								`\u{1F3A8} Theme store ID: ${i}, CSS mode: ${c}`,
							));
				let a = () => {
					e &&
						(console.log(
							"\u{1F3AC} Starting Currency Converter...",
						),
						console.log(
							"\u{1F3D7}\uFE0F Creating CurrencyConverter instance...",
						));
					try {
						let d = new L();
						return (
							e &&
								console.log(
									"\u2705 CurrencyConverter instance created successfully",
								),
							d
						);
					} catch (d) {
						(console.error(
							"\u{1F4A5} Failed to initialize Currency Converter:",
							d,
						),
							console.error("\u{1F41B} Stack:", d.stack),
							e &&
								console.error("\u{1F50D} Error details:", {
									name: d.name,
									message: d.message,
									line: d.lineNumber,
									column: d.columnNumber,
								}),
							e &&
								console.log(
									"\u{1F6A8} Attempting basic fallback...",
								));
						try {
							((window.CurrencyConverter = {
								refresh: () =>
									e &&
									console.log("Converter not initialized"),
								getStats: () => ({
									error: "Converter failed to initialize",
								}),
								destroy: () =>
									e && console.log("Nothing to destroy"),
								version: "2.0.0-error",
							}),
								e &&
									console.log(
										"\u{1F4CB} Basic API created for debugging",
									));
						} catch (d) {
							console.error("\u{1F4A5} Even fallback failed:", d);
						}
					}
				};
				document.readyState === "loading"
					? (e &&
							console.log(
								"\u23F3 Waiting for DOM to be ready...",
							),
						document.addEventListener("DOMContentLoaded", a))
					: (e &&
							console.log(
								"\u2705 DOM already ready, starting immediately",
							),
						a());
			})());
	})();
})();
